export const KHACHHANG_LIST_INITING = 'KHACHHANG_LIST_INITING'
export const KHACHHANG_LIST_REQUESTING = 'KHACHHANG_LIST_REQUESTING'
export const KHACHHANG_LIST_SUCCESS = 'KHACHHANG_LIST_SUCCESS'
export const KHACHHANG_LIST_ERROR = 'KHACHHANG_LIST_ERROR'
export const KHACHHANG_SET_ERROR = 'KHACHHANG_SET_ERROR'
export const KHACHHANG_SET_MESSAGE = 'KHACHHANG_SET_MESSAGE'

export const KHACHHANG_EXPORT_XLS_INITING = 'KHACHHANG_EXPORT_XLS_INITING'
export const KHACHHANG_EXPORT_XLS_REQUESTING = 'KHACHHANG_EXPORT_XLS_REQUESTING'
export const KHACHHANG_EXPORT_XLS_SUCCESS = 'KHACHHANG_EXPORT_XLS_SUCCESS'
export const KHACHHANG_EXPORT_XLS_ERROR = 'KHACHHANG_EXPORT_XLS_ERROR'

export const KHACHHANG_CMB_LIST_INITING = 'KHACHHANG_CMB_LIST_INITING'
export const KHACHHANG_CMB_LIST_REQUESTING = 'KHACHHANG_CMB_LIST_REQUESTING'
export const KHACHHANG_CMB_LIST_SUCCESS = 'KHACHHANG_CMB_LIST_SUCCESS'
export const KHACHHANG_CMB_LIST_ERROR = 'KHACHHANG_CMB_LIST_ERROR'

export const KHACHHANG_USER_LIST_INITING = 'KHACHHANG_USER_LIST_INITING'
export const KHACHHANG_USER_LIST_REQUESTING = 'KHACHHANG_USER_LIST_REQUESTING'
export const KHACHHANG_USER_LIST_SUCCESS = 'KHACHHANG_USER_LIST_SUCCESS'
export const KHACHHANG_USER_LIST_ERROR = 'KHACHHANG_USER_LIST_ERROR'

export const KHACHHANG_DVHC_LIST_INITING = 'KHACHHANG_DVHC_LIST_INITING'
export const KHACHHANG_DVHC_LIST_REQUESTING = 'KHACHHANG_DVHC_LIST_REQUESTING'
export const KHACHHANG_DVHC_LIST_SUCCESS = 'KHACHHANG_DVHC_LIST_SUCCESS'
export const KHACHHANG_DVHC_LIST_ERROR = 'KHACHHANG_DVHC_LIST_ERROR'

export const KHACHHANG_QUANHUYEN_LIST_REQUESTING = 'KHACHHANG_QUANHUYEN_LIST_REQUESTING'
export const KHACHHANG_PHUONGXA_LIST_REQUESTING = 'KHACHHANG_PHUONGXA_LIST_REQUESTING'
export const KHACHHANG_MUC_HOPDONG_LIST_REQUESTING = 'KHACHHANG_MUC_HOPDONG_LIST_REQUESTING'

export const KHACHHANG_DETAIL_INITING = 'KHACHHANG_DETAIL_INITING'
export const KHACHHANG_DETAIL_REQUESTING = 'KHACHHANG_DETAIL_REQUESTING'
export const KHACHHANG_DETAIL_SUCCESS = 'KHACHHANG_DETAIL_SUCCESS'
export const KHACHHANG_DETAIL_ERROR = 'KHACHHANG_DETAIL_ERROR'

export const KHACHHANG_USER_DETAIL_INITING = 'KHACHHANG_USER_DETAIL_INITING'
export const KHACHHANG_USER_DETAIL_REQUESTING = 'KHACHHANG_USER_DETAIL_REQUESTING'
export const KHACHHANG_USER_DETAIL_SUCCESS = 'KHACHHANG_USER_DETAIL_SUCCESS'
export const KHACHHANG_USER_DETAIL_ERROR = 'KHACHHANG_USER_DETAIL_ERROR'

export const KHACHHANG_UPDATE_DIEM_TL_REQUESTING = 'KHACHHANG_UPDATE_DIEM_TL_REQUESTING'
export const KHACHHANG_UPDATE_DIEM_TLS_REQUESTING = 'KHACHHANG_UPDATE_DIEM_TLS_REQUESTING'
export const KHACHHANG_UPDATE_REQUESTING = 'KHACHHANG_UPDATE_REQUESTING'
export const KHACHHANG_UPDATE_SUCCESS = 'KHACHHANG_UPDATE_SUCCESS'
export const KHACHHANG_UPDATE_ERROR = 'KHACHHANG_UPDATE_ERROR'

export const KHACHHANG_REMOVE_REQUESTING = 'KHACHHANG_REMOVE_REQUESTING'
export const KHACHHANG_REMOVE_SUCCESS = 'KHACHHANG_REMOVE_SUCCESS'
export const KHACHHANG_REMOVE_ERROR = 'KHACHHANG_REMOVE_ERROR'

export const KHACHHANG_UPLOAD_REQUESTING = 'KHACHHANG_UPLOAD_REQUESTING'
export const KHACHHANG_UPLOAD_SUCCESS = 'KHACHHANG_UPLOAD_SUCCESS'
export const KHACHHANG_UPLOAD_ERROR = 'KHACHHANG_UPLOAD_ERROR'

export const KHACHHANG_USER_UPDATE_REQUESTING = 'KHACHHANG_USER_UPDATE_REQUESTING'
export const KHACHHANG_USER_UPDATE_SUCCESS = 'KHACHHANG_USER_UPDATE_SUCCESS'
export const KHACHHANG_USER_UPDATE_ERROR = 'KHACHHANG_USER_UPDATE_ERROR'

export const KHACHHANG_DETAIL_API = '/api/v1/khachhang/khachhang_detail_by_id'
export const KHACHHANG_USER_DETAIL_API = '/api/v1/khachhang/khachhang_user_list_by_store'
export const KHACHHANG_LIST_API = '/api/v1/khachhang/khachhang_list_by_store'
export const KHACHHANG_EXPORT_XLS_API = '/api/v1/khachhang/khachhang_export_by_store'
export const KHACHHANG_UPDATE_API = '/api/v1/khachhang/khachhang_update_by_id'
export const KHACHHANG_UPDATE_DIEM_TL_API = '/api/v1/khachhang/khachhang_update_diem_tich_luy'
export const KHACHHANG_UPDATE_DIEM_LIST_TL_API = '/api/v1/khachhang/khachhang_upload_diem_tich_luy'
export const KHACHHANG_UPLOAD_API = '/api/v1/khachhang/khachhang_upload'
export const KHACHHANG_CMB_LIST_API = '/api/v1/khachhang/khachhang_cmb_list'
export const KHACHHANG_USER_LIST_API = '/api/v1/users/users_list_by_store'
export const KHACHHANG_DVHC_LIST_API = '/api/v1/management/dvhc_get_list'
export const KHACHHANG_DVHC_LIST_BY_PARENT_API = '/api/v1/management/dvhc_get_by_parent'
export const KHACHHANG_MUC_HOPDONG_LIST_API = '/api/v1/management/muc_hopdong_list_active_by_store'
export const KHACHHANG_USER_UPDATE_API = '/api/v1/khachhang/khachhang_user_update'
export const KHACHHANG_REMOVE_API = '/api/v1/khachhang/khachhang_remove_by_id'
export const KHACHHANG_FILE_TEMPLATE = '/templates/dsKhachHang.xls';
export const KHACHHANG_FILE_DIEM_TICHLUY_TEMPLATE = '/templates/diemKhachHang.xls';
export const LoaiKhachHang = {
  Default: 1,
  Store: 2
}


// WEBPACK FOOTER //
// ./src/views/KhachHang/constants.js